import { useFieldArray, useForm } from 'react-hook-form';
import { WidgetDTO, WidgetsDTO } from '../../api/useWidgetsQuery';

interface WidgetForm extends WidgetDTO {
  isSelected: boolean;
}

interface FormValues {
  widgets: WidgetForm[];
}

interface Params {
  widgets: WidgetsDTO;
}

export const useAddWidgetModal = ({ widgets }: Params) => {
  const formBag = useForm<FormValues>({
    defaultValues: {
      widgets: [...widgets.excluded]
        .sort((a, b) => a.rank - b.rank)
        .map(widget => ({
          ...widget,
          isSelected: false,
        })),
    },
  });
  const { fields } = useFieldArray({
    control: formBag.control,
    name: 'widgets',
    keyName: 'key',
  });
  const watchFieldArray = formBag.watch('widgets');
  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  return {
    ...formBag,
    fields: controlledFields,
  };
};
